import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../utilities/analytics/tracking';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import PopUp from '../../Shared/Popup/PopUp';
import ServiceBoxPopUp from './ServiceBoxPopUp';
import {report as dwhReport, getReportParams} from '../../../middleware/report';

export default function ServiceBox(
  product,
  txt,
  imgSrc,
  url,
  urls,
  UserServices,
  arrow,
  isOrganizationId,
  context,
  iContent,
  openWorkOrder,
  isWorkOrderSucceeded,
  resetIsWorkOrderSucceeded,
  organizationWorkOrderCode,
  organizationWorkOrderTeam,
  loginData,
) {
  const [showPopUp, setShowPopUp] = useState(false);
  const join = 'להצטרפות';
  const joined = 'כבר יש לך!';
  if (product == 'Internet' && UserServices.includes('InternetInfra')) {
    product = 'InternetInfra';
  }

  useEffect(() => {
    const eventTxt = UserServices.indexOf(product) === -1 ? 'SelfCareServices_JoinServiceImp' : 'SelfCareServices_ServiceExistImp';
    const actionTxt = UserServices.indexOf(product) === -1 ? 'JoinServiceImp' : 'ServiceExistImp';
    gtag4({
      event: eventTxt,
      content: txt,
      action: actionTxt,
    });
    let hasnoProduct = UserServices.indexOf(product) === -1;
    if (hasnoProduct) {
      let message;
      switch (product) {
        case 'Cellular':
          message = 'Join Cellular Product Displayed';
          break;
        case 'TV':
          message = 'Join TV Product Displayed';
          break;
        case 'Internet':
          message = 'Join Internet Product Displayed';
          break;
        case 'Energy':
          message = 'Join Electricity Product Displayed';
          break;
        default:
          message = '';
          break;
      }
      let reportParams = getReportParams();
      reportParams.channel = 'WebsitePrivate';
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'My Zone';
      reportParams.actionType = 'Product Block';
      reportParams.status = 'Ongoing';
      reportParams.messageText = message;
      reportParams.customerName = loginData.userDetails?.firstName + ' ' + loginData.userDetails?.lastName;
      reportParams.subscriber = loginData.userDetails?.contactNumber;
      reportParams.idNumber = loginData.userDetails?.IDNumber;
      dwhReport(reportParams);
    }
  }, []);

  async function goToAndReportGA(txt) {
    report(txt);
    window.location.assign(url);
  }

  function report(txt) {
    gtag4({
      event: 'SelfCareServices_JoinServiceClick',
      content: txt,
      action: 'JoinServiceClick',
      button: join,
    });
    let message;
    switch (product) {
      case 'Cellular':
        message = 'Join Cellular Product Clicked';
        break;
      case 'TV':
        message = 'Join TV Product Clicked';
        break;
      case 'Internet':
        message = 'Join Internet Product Clicked';
        break;
      case 'Energy':
        message = 'Join Electricity Product Clicked';
        break;
      default:
        message = '';
        break;
    }
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.actionType = 'Product Block';
    reportParams.status = 'Ongoing';
    reportParams.messageText = message;
    reportParams.customerName = loginData.userDetails?.firstName + ' ' + loginData.userDetails?.lastName;
    reportParams.subscriber = loginData.userDetails?.contactNumber;
    reportParams.idNumber = loginData.userDetails?.IDNumber;

    dwhReport(reportParams);
  }

  function reportGA(txt) {
    gaEvent(gaParams.OUR_PRODUCTS_SHOW_PRODUCT_BOX.category, gaParams.OUR_PRODUCTS_SHOW_PRODUCT_BOX.eventType, txt);
  }

  function openPopUpAndWorkOrder(product) {
    const data = {
      productName: product,
      productWorkOrderTeam: organizationWorkOrderTeam,
      productWorkOrderCode: organizationWorkOrderCode,
    };
    openWorkOrder(data);
  }

  console.log('id', isOrganizationId);

  if (UserServices.indexOf(product) === -1) {
    return (
      <div className='service-box-container'>
        <PopUp
          showPopUp={showPopUp}
          onClose={() => {
            setShowPopUp(false);
            resetIsWorkOrderSucceeded();
          }}>
          <ServiceBoxPopUp
            context={context}
            iContent={iContent}
            isPopUp={true}
            product={product}
            organizationWorkOrderCode={organizationWorkOrderCode}
            organizationWorkOrderTeam={organizationWorkOrderTeam}
            showPopUp={setShowPopUp}
            isWorkOrderSucceeded={isWorkOrderSucceeded}
            openPopUpAndWorkOrder={openPopUpAndWorkOrder}
            resetIsWorkOrderSucceeded={resetIsWorkOrderSucceeded}
            footerButton={<BtnSubmit onclick={() => setShowPopUp(false)} text='סגור' />}
          />
        </PopUp>
        <div className='top-container'>
          <Image className='img' src={imgSrc} />
          <div className='txt'>{txt}</div>
        </div>
        <div className='bottom-container'>
          <a
            className='linkTo'
            href={!isOrganizationId ? url : 'javascript:void(0)'}
            onClick={() => (!isOrganizationId ? goToAndReportGA(txt) : setShowPopUp(true))}>
            {join}
          </a>
        </div>
      </div>
    );
  } else {
    reportGA(txt);
    return (
      <div className='service-box-container'>
        <div className='top-container'>
          <Image className='img' alt='image' src={imgSrc} />
          <div className='txt'>{txt}</div>
        </div>
        <div className='bottom-container'>
          <div className='txt'>{joined}</div>
        </div>
      </div>
    );
  }
}
